import { ethers } from "ethers";
import { useEffect, useState } from "react";

const FlowRate = ({ rate, isFlow, currentFlowRate }) => {
  const [latestRate, setLatestRate] = useState(
    +ethers.utils.formatUnits(`${rate}`, 18)
  );

  const [count, setCount] = useState(0);

  useEffect(() => {
    if (isFlow) {
      setTimeout(() => {
        const minSecRate =
          +ethers.utils.formatUnits(`${currentFlowRate}`, 18) / 120;
        const addRate = +latestRate + +minSecRate;
        setLatestRate(addRate);
        setCount(count + 1);
      }, 10);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [count]);

  let ceilNum = 4;
  if (isFlow) {
    ceilNum = 7;
  } else if (latestRate < 0.1) {
    ceilNum = 6;
  } else {
    ceilNum = 4;
  }
  return <div>{latestRate.toFixed(ceilNum)}</div>;
};

export default FlowRate;
